import Vue from "vue";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/display.css';
// import '../public/static/css/index.css'

import App from "./App.vue";
import router from "./router";
import store from "./store";

// echarts 组件 开始

import echarts from 'echarts'
Vue.prototype.$echarts = echarts;

// echarts 组件 结束

//vue-cookies 引入
import VueCookies from 'vue-cookies'
Vue.use(VueCookies);
//vue-cookies 结束

//vue i18n 引入
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

// 准备翻译的语言环境信息
const i18n = new VueI18n({
  locale: 'en',  // 语言标识
  messages: {
      'zh': require('./common/lang/zh.json'),
      'en': require('./common/lang/en.json')
  }
})
//vue i18n 引入结束

Vue.config.productionTip = false;
Vue.use(ElementUI);
new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");

